module.exports = __webpack_public_path__ + "static/media/pdi-image-05.313081d9.svg";